<template>
  <div class="offcanvas offcanvas-start" tabindex="-1" id="sidebarPanel">
    <div class="offcanvas-body">
      <!-- profile box -->
      <div class="profileBox">
        <div class="image-wrapper">
          <img src="/assets/img/logo-transparent.png"  alt="image" class="imaged rounded" style="width: 55px;" />
        </div>
        <div class="in">
          <!-- <strong>راننده گرامی</strong> -->
          <strong>ایران ترابر رانندگان</strong>
          <!-- <div class="text-muted">
            <ion-icon name="location"></ion-icon>
            <span class="text-light" v-if="isLoggedIn">ایران</span>
            <span class="text-light" v-else>ایران</span>
          </div> -->
        </div>
        <a href="#" class="close-sidebar-button" data-bs-dismiss="offcanvas">
          <ion-icon name="close"></ion-icon>
        </a>
      </div>
      <!-- * profile box -->

      <ul class="listview flush transparent no-line image-listview mt-2">
        <!--        <li v-if="isLoggedIn">-->
        <!--          <a href="#" class="item">-->
        <!--            <div class="icon-box bg-danger">-->
        <!--              <ion-icon name="home"></ion-icon>-->
        <!--            </div>-->
        <!--            <div class="in">-->
        <!--              پروفایل-->
        <!--            </div>-->
        <!--          </a>-->
        <!--        </li>-->
        <!-- <li v-if="isLoggedIn">
          <a href="https://www.goftino.com/c/vLBTmK" class="item">
            <div class="icon-box background-ORANGE text-light">
              <ion-icon name="chatbubbles"></ion-icon>
            </div>
            <div class="in">گفتگو آنلاین</div>
          </a>
        </li> -->
        <!-- <li>
          <a href="https://www.goftino.com/c/vLBTmK" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="chatbubbles"></ion-icon>
            </div>
            <div class="in">
              گفتگو آنلاین
            </div>
          </a>
        </li> -->
        <!-- <li>
          <a href="/callHistory" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="call"></ion-icon>
            </div>
            <div class="in">تاریخچه تماس ها</div>
          </a>
        </li> -->
        <li>
          <a href="/services" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="settings-outline"></ion-icon>
            </div>
            <div class="in">خدمات</div>
          </a>
        </li>
        <li>
          <a href="/faq" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="help"></ion-icon>
            </div>
            <div class="in">سوالات متداول</div>
          </a>
        </li>
        <li>
          <a href="/terms-and-conditions" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="help-buoy"></ion-icon>
            </div>
            <div class="in">قوانین و مقررات</div>
          </a>
        </li>
        <li v-if="isLoggedIn">
          <a href="/feedback" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="thumbs-up"></ion-icon>
            </div>
            <div class="in">
              <div>انتقاد و شکایات</div>
            </div>
          </a>
        </li>
        <!-- <li v-if="isLoggedIn">
          <a href="/feedbackFollow" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="reader"></ion-icon>
            </div>
            <div class="in">
              <div>پیگیری شکایات</div>
            </div>
          </a>
        </li> -->
        <li v-if="isLoggedIn">
          <a href="#" @click="logout()" class="item">
            <div class="icon-box background-TEAL text-light">
              <ion-icon name="log-out"></ion-icon>
            </div>
            <div class="in">
              <div>خروج از برنامه</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!-- sidebar buttons -->
    <div class="sidebar-buttons">
      <button type="button" class="btn background-ORANGE text-light btn-block" data-bs-toggle="offcanvas" @click="backTel()"
        data-bs-target="#actionSheetShare" style="height: 3.5rem;font-size: 1rem;">
        پشتیبانی
      </button>
    </div>
    <!-- * sidebar buttons -->
  </div>
  <div class="offcanvas offcanvas-bottom action-sheet inset" tabindex="-1" id="actionSheetShare">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">پشتیبانی</h5>
      <a href="#" id="offTell" class="offcanvas-close" style="display: none"
        data-bs-dismiss="offcanvas">
        <ion-icon name="close-outline"></ion-icon>
      </a>
    </div>
    <div class="offcanvas-body">
      <ul class="action-button-list">
        <li>
          <a :href="'tel:' + tel" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="call"></ion-icon>
              تماس
            </span>
          </a>
        </li>
        <li>
          <a href="https://www.goftino.com/c/vLBTmK" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="chatbubbles"></ion-icon>
              گفتگو آنلاین
            </span>
          </a>
        </li>
        <li>
          <a href="/support" class="btn btn-list">
            <span>
              <ion-icon class="text-TEAL" name="navigate"></ion-icon>
              ارسال تیکت
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
// import { useRouter } from 'vue-router';

export default {
  name: "sidebar",
  data() {
    return {
      tel: window.localStorage.getItem("tel"),
    };
  },
  methods:{
    backTel(){
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }
  },
  setup() {
    // const router = useRouter();

    function logout() {
      Swal.fire({
        title: "مایل به خروج از حساب کاربری هستید؟",
        // text: "لطفا بعد از خروج دوباره لاگین کنید!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#068B80",
        cancelButtonColor: "#068B80",
        cancelButtonText: "خیر",
        confirmButtonText: "بله!",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("idUser");
          // router.push({ name: 'login' })
          location.href = "/login";

          // Swal.fire({
          //   title: "Deleted!",
          //   text: "Your file has been deleted.",
          //   icon: "success",
          // });
        }
      });

      // localStorage.removeItem("idUser");
      // router.push({ name: 'login' })
      // location.href = "/login";
    }
    return {
      logout,
    };
  },
  computed: {
    isLoggedIn() {
      return window.localStorage.getItem("idUser");
    },
  },
};
</script>
<style>
@import "../assets/css/custom.css";
</style>